import type { MeResponse } from '@/features/auth/types';

export async function fetchMe(): Promise<MeResponse> {
  const res = await fetch('/api/me', { credentials: 'same-origin' });
  if (!res.ok) {
    throw new Error(`Request failed with status ${res.status}`);
  }
  return res.json();
}
